module.exports = __webpack_public_path__ + "97f21d8e4b0d9820c448e92d5550719a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/8.jpg
// module id = 1367
// module chunks = 47